/**
 * Which physical edges of a horizontal scroller have more content beyond
 * them. In RTL the start is the right edge and browsers report scrollLeft
 * from 0 at the start down to -max, so the logical offset is negated before
 * mapping back to left/right.
 */
export function horizontalEdgeMasks(args: {
  scrollLeft: number;
  scrollWidth: number;
  clientWidth: number;
  rtl: boolean;
}): { left: boolean; right: boolean } {
  const { scrollWidth, clientWidth, rtl } = args;
  const maxOffset = scrollWidth - clientWidth;
  if (maxOffset <= 1) return { left: false, right: false };
  const offset = rtl ? -args.scrollLeft : args.scrollLeft;
  const beforeStart = offset > 0;
  const beforeEnd = offset < maxOffset - 1;
  return rtl
    ? { left: beforeEnd, right: beforeStart }
    : { left: beforeStart, right: beforeEnd };
}
